import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const misc: Palette[] = [
    {
        id: GDFPalletCode.contrail,
        name: 'Contrail regions',
        type: 'categorical',
        entries: [
            { label: '', color: '#000000', hide: true },
            { label: 'Low', color: '#f0ae94' },
            { label: 'Moderate', color: '#ea7a5b' },
            { label: 'High', color: '#d74536' },
            { label: 'Extreme', color: '#992823' }
        ]
    },
    {
        id: GDFPalletCode.volcash_light,
        name: 'Volcanic ash',
        type: 'categorical',
        entries: [
            { label: 'Quiet / no report', color: '#000000' },
            { label: 'Non eruptive', color: '#91ed90' },
            { label: 'Elevated unrest', color: '#ffff01' },
            { label: 'Heightened unrest', color: '#ffa501' },
            { label: 'Eruption imminent / underway', color: '#ff0000' }
        ]
    },
    {
        id: GDFPalletCode.volcash_dark,
        name: 'Volcanic ash',
        type: 'categorical',
        entries: [
            { label: 'Quiet / no report', color: '#ffffff' },
            { label: 'Non eruptive', color: '#91ed90' },
            { label: 'Elevated unrest', color: '#ffff01' },
            { label: 'Heightened unrest', color: '#ffa501' },
            { label: 'Eruption imminent / underway', color: '#ff0000' }
        ]
    },
    {
        id: GDFPalletCode.volcash_cloud2,
        name: 'Volcanic ash clouds',
        type: 'categorical',
        entries: [
            { label: 'Low 0.2-2.0 mg/m3', color: 'rgb(164, 208, 253)' },
            { label: 'Medium 2.0-5.0 mg/m3', color: 'rgb(254, 155, 42)' },
            { label: 'High 5.0-10.0 mg/m3', color: 'rgb(255, 33, 25)' },
            { label: 'Very high >= 10.0 mg/m3', color: 'rgb(177, 0, 166)' }
        ]
    },
    {
        id: GDFPalletCode.tropical,
        name: 'Tropical cyclones',
        type: 'categorical',
        entries: [
            { label: '', color: '#000', hide: true },
            { label: '12 to 34 kts', color: '#65ffff' },
            { label: '34 to 50 kts', color: '#87dfbe' },
            { label: '50 to < 64 kts', color: '#a1ea7f' },
            { label: '>= 64kts', color: '#c59854' }
        ]
    },
    {
        id: GDFPalletCode.watchwarn,
        name: 'Watches Warnings',
        type: 'categorical',
        entries: [
            { label: "Severe T'storm", color: '#ffff01' },
            { label: 'Tornado watch', color: '#ff0000' },
            { label: "Severe T'storm warning", color: '#fa7d00' },
            { label: 'Tornado warning', color: '#990001' }
        ]
    },
    {
        id: GDFPalletCode.centerWeatherAdvisory,
        name: 'Center Weather Advisory',
        type: 'categorical',
        entries: [
            { label: "T'storm", color: 'rgb(128,0,0)' },
            { label: 'Turbulence', color: 'rgb(160,96,0)' },
            { label: 'Icing', color: 'rgb(0,0,128)' },
            { label: 'IFR', color: 'rgb(63,0,63)' },
            { label: 'Precip', color: 'rgb(255,0,255)' },
            { label: 'Unknown', color: 'rgb(139,139,139)' }
        ]
    }
];
